import { render, staticRenderFns } from "./property-page.vue?vue&type=template&id=771c5cc6&scoped=true&"
import script from "./property-page.vue?vue&type=script&lang=ts&"
export * from "./property-page.vue?vue&type=script&lang=ts&"
import style0 from "./property-page.vue?vue&type=style&index=0&id=771c5cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771c5cc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VNavigationDrawer,VRow})
